module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAAXNSR0IArs4c6QAAABJQTFRFAAAA////qqqqfn6Bfn6BfX6ATK8FywAAAAV0Uk5TAAEDf7787yQ/AAAATklEQVQ4y2NgwAOMkQAyDygVigSQefilwLpNQp2xGAgGzKEGuNwyPKTweBkloIiWGg1DOocho5IAw1AExjgAWoZFzbz4pPAYOBoaRIUGAOAdbU/phC43AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/rich-text-icon.png
// module id = XrWr
// module chunks = 241